export default "/_next/static/images/cc92546e2f5478d10a1071dc4bf805e4.png";